import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { base64ToString, parseJsonTo } from 'src/app/core/utils/utils';

import { AppRoute } from 'src/app/constants/app.route';
import { AuthUserService } from 'src/app/core/services/auth/auth-user.service';
import { SchoolAuthExternal } from 'src/app/core/services/http/auth/interface/school-auth-external';
import { SchoolService } from '../../core/services/http/school/school.service';
import { School } from '../../core/services/http/school/interfaces/school';

@Component({
  template: ''
})
export class AuthExternalCallBackComponent implements OnInit {
  base64ToString = base64ToString;
  parseJsonTo = parseJsonTo;

  constructor(
    private activatedRoute: ActivatedRoute,
    private authUserService: AuthUserService,
    private router: Router,
    private schoolService: SchoolService
  ) {}

  ngOnInit(): void {
    const authparams = this.activatedRoute.snapshot.queryParams.authparams;

    if (authparams) {
      const schoolAuthExternalString = this.base64ToString(this.activatedRoute.snapshot.queryParams.authparams);
      const schoolAuthExternal = this.parseJsonTo<SchoolAuthExternal>(decodeURIComponent(schoolAuthExternalString));

      if (schoolAuthExternal) {
        this.authUserService.setUserDataBySchoolAuthExternal(schoolAuthExternal);
        this.schoolService.getSchool().subscribe((ftmSchool: School) => {
          ftmSchool.role = schoolAuthExternal.school.role;
          schoolAuthExternal.school = ftmSchool;
          this.authUserService.setUserDataBySchoolAuthExternal(schoolAuthExternal);
        });

        this.router.navigateByUrl(AppRoute.Dashboard);
      }
    }
  }
}
